import { przezmorzeApi } from "../../../api/api";
import type { ProductGroup, ProductGroupListResponse, UpdateProductGroupRequest } from "@przezmorze/api-types";

export type { ProductGroup };
export type UpdateProductGroupRequestBody = UpdateProductGroupRequest;

export async function listProductGroups(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<ProductGroupListResponse>("/product-groups", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addProductGroup(
  body: Omit<ProductGroup, "id">,
  abortSignal?: AbortSignal,
): Promise<ProductGroup> {
  const response = await przezmorzeApi.post<ProductGroup>("/product-groups", body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function updateProductGroup(
  groupId: string,
  body: UpdateProductGroupRequestBody,
  abortSignal?: AbortSignal,
) {
  const response = await przezmorzeApi.patch<ProductGroup>(`/product-groups/${groupId}`, body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function deleteProductGroup(id: string, force: boolean, abortSignal?: AbortSignal): Promise<void> {
  await przezmorzeApi.delete(`/product-groups/${id}`, {
    params: { force },
    signal: abortSignal,
  });
}
